import { render } from "./VartaMineria.vue?vue&type=template&id=30803488&scoped=true&class=banner"
import script from "./VartaMineria.vue?vue&type=script&lang=js"
export * from "./VartaMineria.vue?vue&type=script&lang=js"

import "./VartaMineria.vue?vue&type=style&index=0&id=30803488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30803488"]])

export default __exports__